import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { refreshCustomerAddressesList, setCustomerAddresses }
  from 'components/actions/serviceActions';
import { connect } from 'react-redux';
import AddressItem from './components/AddressItem';
import withRouter from 'components/components/common/withRouter';
import TransHelper from 'components/common/translations/TransHelper';

class ListPlaces extends Component {

  handleClickAddNewAddress = (event) => {
    TransHelper.redirect(this.props, 'routes.url.accountPlacesMap')
  }

  renderAddresses = () => {
    const { customerAddresses } = this.props;
    var results = [];
    for (var i = 0; i < customerAddresses.length; i++) {
      var address = customerAddresses[i];
      results.push(
        <AddressItem
          key={address.id}
          {...address}
          refreshList={this.props.refreshCustomerAddressesList}
          locale={this.props.locale}
        />
      )
    }
    return results;
  }

  trans = (key, pref = "content.account.places.list") => {
    return TransHelper.translate(this.props.locale, pref + "." + key);
  }

  render() {
    const { customerAddresses } = this.props;
    return (
      <div className="list-places-wrap">
        {customerAddresses.length === 0 &&
          <div className="message message--info" style={{ marginBottom: '50px' }}>
            <p>{this.trans('favPlacesEmpty')}</p>
          </div>
        }

        <ul className="list-border list-border--delete">
          {this.renderAddresses()}
        </ul>
        <button onClick={this.handleClickAddNewAddress} >
          <FontAwesomeIcon
            className="list-border__icon"
            icon={['fas', 'plus-circle']}
          />{this.trans('addNewAddress')}
        </button>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    refreshParam: state.service.refreshCustomerAddressesList,
    customerAddresses: state.service.customerAddresses,
    locale: state.app.locale
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    { refreshCustomerAddressesList, setCustomerAddresses }
  )(ListPlaces)
);
